export const environment = {
    applicationVersion: '0.0.1',
    appDomain: 'kiwid.com.br',
    apiUrl: 'https://api-staging.kiwid.com.br:3000',
    apiUrlCommunication: 'https://api-communication-staging.kiwid.com.br:3001',
    termsUrl: 'https://kiwid.app/pt-BR/terms',
    apiVersion: 'v1',
    type: 'staging',
    titleBase: 'Kiwid',
    production: true,
    oAuthGoogleKey: '414357400793-8j4ublm2dadg0pqqiu8jj04fsv9441ik.apps.googleusercontent.com',
    googleApiKey: 'AIzaSyCkleGTioBk2q8mfwAQAUepCDismE25brU',
    facebookId: '764676070765214',
    appleClientId: 'app.kiwid.Clinic.web.dev',
    appleRedirectUrl: 'https://lab-staging.kiwid.com.br/auth/login',
    socketUnauthorized: 'd6097211e6a5fd7157c9',
    firebase: {
        apiKey: 'AIzaSyCkleGTioBk2q8mfwAQAUepCDismE25brU',
        authDomain: 'kiwid-d52a7.firebaseapp.com',
        databaseURL: 'https://kiwid-d52a7.firebaseio.com',
        projectId: 'kiwid-d52a7',
        storageBucket: 'kiwid-d52a7.appspot.com',
        messagingSenderId: '414357400793',
        appId: '1:414357400793:web:6079a53c02fc0f7245a2c8',
        measurementId: 'G-L8RLVNZH6P',
        vapidKey: 'BAPsp9eLDLGv_x2Nc-DUF6H7MQ0n51SinoSUKG8fBRnu-rTwHMBHwo5uB3cbhz9Rx6FvE2PgyVQr_msp-H7smzQ',
    },
    maxYearBirthdate: 5,
    minYearBirthdate: 95,
    hmr: false,
    helpChat: {
        timezoneName: 'America/Sao_Paulo',
        startHour: '08:00:00',
        endHour: '17:00:00',
    },
};
